import Header from "../../header/Header";
import Review from "../review_info/Review";
import Footer from "../../footer/Footer";

function ReviewLanding(){
    return(
        <div className="review_landing">
            <Header />
            <Review />
            <Footer />
        </div>
    )
}

export default ReviewLanding